"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

var colors_1 = require("@headspace/hs-web-style-guide/dist/colors");

var font_1 = require("@headspace/hs-web-style-guide/dist/font");

var colors = {
  green: colors_1.deYork,
  red: colors_1.burntSienna,
  yellow: colors_1.goldenrod,
  grey: colors_1.silverChalice,
  blue: colors_1.seagull2
};
var statusGroupStyle = hs_web_style_guide_1.css({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
});

var statusStyle = function statusStyle(color) {
  return hs_web_style_guide_1.css({
    fontSize: 14,
    color: color === 'grey' ? colors_1.silverChalice : colors_1.tundora
  });
};

var statusColorStyle = function statusColorStyle(color) {
  return hs_web_style_guide_1.css({
    borderRadius: '50%',
    width: 8,
    height: 8,
    backgroundColor: colors[color],
    marginRight: 10
  });
};

function StatusText(props) {
  var color = props.color,
      status = props.status;
  return React.createElement("div", __assign({}, statusGroupStyle), React.createElement("div", __assign({}, statusColorStyle(color))), React.createElement("div", __assign({}, statusStyle(color), font_1.regular), status));
}

exports.StatusText = StatusText;